import React from "react"
import About from "../components/aboutAia/About-aia"
import SEO from "../components/seo"
import { getAboutPageJsonLd } from "../utils/jsonld"

const Aboutaia = () => {
  return (
    <>
      <SEO
        title="BIM & CAD Training Center | Ace Industrial Academy"
        description="Ace Industrial Academy is a leading training center in Singapore for IT courses, BIM courses, 3D CAD courses, 4D courses, software courses, building information modeling courses and more."
        jsonLd={getAboutPageJsonLd()}
      />
      <div>
        <About />
      </div>
    </>
  )
}
export default Aboutaia
